import { useState } from "react";

export const faqs = [
  { q: "Can I get an emergency passport in Tupelo?", a: "Yes — emergency passport service is available for Tupelo residents with urgent departures. As a registered State Department courier, we process applications as fast as 24 hours. Call 877-253-0084 to verify eligibility." },
  { q: "Where do I apply for a passport in Tupelo?", a: "The Tupelo Main Post Office on Cliff Gookin Boulevard and the Lee County Circuit Clerk's office are primary acceptance agents. Both require appointments. For renewals, you can mail directly to us without a post office visit." },
  { q: "How close is Tupelo to a regional passport agency?", a: "The nearest regional passport agency is in Nashville (about 3 hours north) or Memphis (90 minutes west). Our private courier service eliminates the need to drive to either city for urgent processing." },
  { q: "Can Toyota Mississippi employees use your service?", a: "Absolutely. Toyota Motor Manufacturing Mississippi team members traveling to Japan or other Toyota global facilities for training and exchanges are a priority for us. We handle group applications for corporate travel programs." },
  { q: "Do you serve Saltillo, Pontotoc, and surrounding areas?", a: "Yes, we serve all of Northeast Mississippi including Saltillo, Pontotoc, Corinth, New Albany, Fulton, Baldwyn, and all surrounding Lee County communities. No office visit is required." },
  { q: "How does an Elvis birthplace tourist get an emergency passport?", a: "Whether you are a Tupelo local or a visitor whose passport was lost or stolen, we can process emergency replacements. Our lost-and-stolen service includes DS-64 guidance and fastest available reissue." },
  { q: "Can ICC students get rush passports?", a: "Yes. Itawamba Community College students accepted for international programs with short notice can use our rush or emergency service. We understand academic calendars and can coordinate with campus advisors." },
  { q: "What is the best price guarantee?", a: "We are a registered U.S. Department of State courier — not a reseller. Our rates are typically 30–100% lower than FedEx, Staples, and other third-party passport courier services. If you find a lower rate for the same service, we match it." },
];

export default function TupeloFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Tupelo Passport <span className="text-[#F6C344]">Questions</span>
          </h2>
        </div>
        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap">
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}